import type { BlockReason, TimeBlock } from '../model/schema'

/**
 * Подписи причин — язык команды: «выходной», а не `day-off`. Порядок задаёт
 * порядок пресетов в карточке: сперва то, что ставят чаще.
 */
export const REASON_LABELS: Record<BlockReason, string> = {
  'day-off': 'выходной',
  busy: 'занят',
  vacation: 'отпуск',
  sick: 'болеет',
  other: 'своё',
}

/**
 * Что написано на блоке в сетке. Своя подпись перевешивает причину: человек
 * писал её именно затем, чтобы её и прочли.
 */
export function blockLabel(block: TimeBlock): string {
  if (block.reason === 'other') return block.note || REASON_LABELS.other
  return REASON_LABELS[block.reason]
}

/** Уточнение под подписью: для причины из списка — своими словами, если есть. */
export function blockDetail(block: TimeBlock): string | null {
  if (block.reason === 'other') return null
  return block.note || null
}
